import Swiper from 'swiper'
import SwiperCore, {Navigation} from 'swiper/core'

SwiperCore.use([Navigation])

export default class ProductAnimationSlider {
  constructor(component) {
    this.dom = {
      $component: component,
      $slides: component.querySelectorAll('.js-productAnimationSlide')
    }
    this.state = {
      swiper: null,
      observer: null,
      animatedClass: 'hasAnimated'
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
    this.observe()
  }

  observe() {
    const {dom, state} = this
    const rootMargin = window.innerWidth <= 800 ? '0px 0px -350px 0px' : '0px 0px -275px 0px'
    state.observer = new IntersectionObserver(this.onIntersection.bind(this), {rootMargin})
    state.observer.observe(dom.$component)
  }

  onIntersection(entries) {
    const {state} = this
    const entry = entries[0]

    if (entry.isIntersecting) {
      this.animate()
      state.observer.unobserve(entry.target)
    }
  }

  async animate(count = 0) {
    const {dom, state} = this
    const slides = dom.$slides.length * 2
    if (count === slides) {
      await new Promise(resolve => setTimeout(resolve, 500))
      dom.$component.classList.add(state.animatedClass)
      return
    }

    state.swiper.slideNext()
    await new Promise(resolve => setTimeout(resolve, 150))
    return this.animate(count + 1)
  }

  initSlider() {
    const {state} = this
    state.swiper = new Swiper('.js-productAnimationSwiper', {
      loop: true,
      speed: 1,
      allowTouchMove: false,
      navigation: {
        prevEl: '.js-productAnimationSwiperButtonPrev',
        nextEl: '.js-productAnimationSwiperButtonNext'
      }
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductAnimationSlider = this
  }
}
